// Pencil-on-paper palette. Keep in sync with tailwind.config in public/index.html.
// (Token names kept from the earlier palette so components didn't need renaming.)
export const palette = {
  paper: "#f4eee4",
  ink: "#3a3530",
  inkSoft: "#6f675e",
  blue: "#56709f", // slate: the signal line and most drawings
  pink: "#c2603f", // rust: small accents
  yellow: "#d9a94b", // ochre
  moss: "#7d9a6c",
  navy: "#26231f", // night chapter
  night: "#efe8dc", // text on the night chapter
  misprint: "transparent", // the old riso offset layer, now switched off

  // names the art pieces use
  pen: "#56709f",
  signal: "#c2603f",
};
